import { removeAtIndex } from './removeAtIndex'
import { updatedAtIndex } from './updateAtIndex'

export const updateOrRemoveAtIndex = <T>(array: T[], targetIndex: number, newValue: T, remove?: boolean): T[] => {
  if (remove) return removeAtIndex(array, targetIndex)

  return updatedAtIndex(array, targetIndex, newValue)
}
